
    import "src/app/AppSeller/SettingsPage/Integrations/SalesChannels/index.module.scss?farm_css_modules";
    
    export default {"integrationCardsContainer": `integrationCardsContainer-4008ca1c`,"integrationsPage": `integrationsPage-4008ca1c`}
    